// Founder note — the honest trust section while there are no customer
// testimonials yet. No fake quotes, no invented metrics: just who made it,
// why, and a direct line. Swap/augment with real customer quotes once the
// first buyers exist.
const FOUNDER_EMAIL = 'alek@alekhagopian.com';

const FounderNote = () => {
  return (
    <section className="founder" id="founder">
      <div className="section-container">
        <p className="overline overline--center">FROM THE FOUNDER</p>
        <h2 className="section-title">Who's behind this</h2>

        <div className="founder-card">
          <p>
            I'm Alek, and I built Solidly because I wanted my Claude subscription to act like a
            team — a researcher running before I wake up, a notetaker that knows who said what,
            an engineer that picks up the action items — without handing my work to another
            SaaS that holds my data. So it runs on your machine, on your own keys, because
            that's the only version I'd use myself.
          </p>
          <p>
            And I do use it, every day — Solidly's own standups, research runs, and meeting
            notes go through the app. If you have a question before buying, email me directly
            and you'll get an answer from me, not a ticket queue. If it isn't for you, the
            7-day refund is one email — no forms, no questions.
          </p>
          <p className="founder-signature">
            — Alek Hagopian, maker of Solidly ·{' '}
            <a href={`mailto:${FOUNDER_EMAIL}`}>{FOUNDER_EMAIL}</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FounderNote;
